import * as React from 'react';

import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const Icon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.00002 16.2L4.80002 12L3.40002 13.4L9.00002 19L21 6.99998L19.6 5.59998L9.00002 16.2Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
};

export default Icon;
